import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { connect } from 'react-redux'

import EndUserAuthenticationModalPresentation from 'components/Admin/Surveys/ZendeskIntegrationSettings/EndUserAuthenticationModal'

import {
  activateZendeskSatisfactionRatingBackwardSyncAndReturnSuccess,
  getZendeskEndUserCredential,
} from 'actions'
import { toast } from 'libs/toast'
import { connectApi } from 'libs/connectApi'

class EndUserAuthenticationModal extends React.Component {
  static propTypes = {
    activateZendeskSatisfactionRatingBackwardSync: PropTypes.func.isRequired,
    endUserCredential: PropTypes.object,
    getZendeskEndUserCredential: PropTypes.func.isRequired,
    isZendeskEndUserAuthenticationFailed: PropTypes.bool,
    disabled: PropTypes.bool,
  }

  state = {
    modalOpen: false,
    isLoading: false,
    email: '',
    password: '',
  }

  handleOpen = () =>
    this.setState({
      modalOpen: true,
    })

  handleClose = () => {
    this.setState({
      modalOpen: false,
    })
  }

  onEmailChange = (event) => {
    this.setState({
      email: event.target.value,
    })
  }

  onPasswordChange = (event) => {
    this.setState({
      password: event.target.value,
    })
  }

  endUserAuthenticationFormSubmitButtonRef = React.createRef()

  onClickAuthenticate = () => {
    this.endUserAuthenticationFormSubmitButtonRef.current.click()
  }

  authenticateEndUser = async (event) => {
    event.preventDefault()
    this.setState({
      isLoading: true,
    })

    const requestPermissionData = {
      integration_type: 'update_internal_note',
      source: 'zendesk',
      credential: {
        username: this.state.email,
        password: this.state.password,
        subdomain: this.props.subdomainCredential,
      },
    }

    const shouldNotCallActivate = await this.props.checkIntegrationPermission
      .callApi({
        data: requestPermissionData,
      })
      .then((response) => {
        if (response.update_internal_note !== true) {
          toast.error(
            "Oops! You cannot connect using admin credentials. Please use an end-user's email address."
          )
          return true
        } else {
          toast.success(
            'Great work! New feedback will now add satisfaction ratings back to Zendesk.'
          )
          return false
        }
      })
      .catch((error) => {
        let errorMessage = R.pathOr(
          'Oops! Something went wrong. Please contact Simplesat support for help.',
          ['error', 'title'],
          error.data
        )
        if (errorMessage.includes('No help desk')) {
          errorMessage =
            "Uh oh. The subdomain you've entered isn't working. Please make sure you're using the correct one."
        }
        toast.error(errorMessage)
        return true
      })

    if (shouldNotCallActivate) {
      this.setState({
        isLoading: false,
      })
      return
    }

    this.props
      .activateZendeskSatisfactionRatingBackwardSync(this.state.email, this.state.password)
      .then((isSuccess) => {
        this.setState({
          isLoading: false,
        })
        return isSuccess && this.handleClose()
      })
  }

  componentDidMount = async () => {
    await this.props.getZendeskEndUserCredential()
    this.setState({
      email: this.props.endUserCredential.email,
      password: this.props.endUserCredential.password,
    })
  }

  render() {
    return (
      <EndUserAuthenticationModalPresentation
        modalOpen={this.state.modalOpen}
        handleOpen={this.handleOpen}
        handleClose={this.handleClose}
        email={this.state.email}
        password={this.state.password}
        onEmailChange={this.onEmailChange}
        onPasswordChange={this.onPasswordChange}
        onClickAuthenticate={this.onClickAuthenticate}
        authenticateEndUser={this.authenticateEndUser}
        endUserAuthenticationFormSubmitButtonRef={this.endUserAuthenticationFormSubmitButtonRef}
        isZendeskEndUserAuthenticationFailed={this.props.isZendeskEndUserAuthenticationFailed}
        isLoading={this.state.isLoading}
        disabled={this.props.disabled}
      />
    )
  }
}

const mapState = ({ data, pages }) => ({
  isZendeskEndUserAuthenticationFailed: pages.surveys.isZendeskEndUserAuthenticationFailed,
  endUserCredential: data.integrations.zendesk.endUser,
  subdomainCredential: data.integrations.zendesk.authentication.subdomain,
})

const mapDispatch = (dispatch, ownProps) => ({
  activateZendeskSatisfactionRatingBackwardSync: (email, password) =>
    dispatch(
      activateZendeskSatisfactionRatingBackwardSyncAndReturnSuccess(
        email,
        password,
        ownProps.surveyId
      )
    ),
  getZendeskEndUserCredential: () => dispatch(getZendeskEndUserCredential()),
})

export default R.compose(
  connectApi({
    name: 'checkIntegrationPermission',
    url: 'survey/check-integration-permission/',
    method: 'post',
    skip: true,
  }),
  connect(mapState, mapDispatch)
)(EndUserAuthenticationModal)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/containers/Admin/Surveys/ZendeskIntegrationSettings/EndUserAuthenticationModal.js